// Manual mapping for runtime OpenAPI response validation, one entry per transport order endpoint.
// Update this whenever the generated RTK endpoint names or the transport orders OpenAPI operations change.
//
// `withOpenApiResponseValidation` fails closed, so an endpoint missing from this map rejects its
// response with `MISSING_ENDPOINT_SCHEMA` after the request has already succeeded. The `satisfies`
// clause turns that runtime failure into a compile error: the keys are checked against the endpoint
// names of the generated api, so regenerating with a new operation breaks the build until it is
// mapped here. Keys are RTK endpoint names, not OpenAPI operation ids.

import {
    get_GetTransportOrder,
    get_GetTransportOrderRoute,
    get_ListCurrentTransportOrders,
    get_ListEligibleTransportOrderVehicles,
    get_ListTransportOrders,
    patch_UpdateTransportOrder,
    post_CancelTransportOrder,
    post_CreateTransportOrder,
} from './generated/transportOrders.zod';
import type { transportOrdersApi } from './generated/transportOrdersApi';
import type { OpenApiResponseSchemas } from './validatingBaseQuery';

type TransportOrderEndpointName =
    | keyof typeof transportOrdersApi.endpoints
    // Handwritten endpoint, injected by src/api/currentTransportOrdersByStatus.ts rather than generated.
    | 'listCurrentTransportOrdersByStatus';

export const transportOrdersEndpointSchemas = {
    listCurrentTransportOrders: get_ListCurrentTransportOrders,
    // Same operation, called with the status filter the document does not describe yet.
    // See src/api/currentTransportOrdersByStatus.ts.
    listCurrentTransportOrdersByStatus: get_ListCurrentTransportOrders,
    listTransportOrders: get_ListTransportOrders,
    createTransportOrder: post_CreateTransportOrder,
    listEligibleTransportOrderVehicles: get_ListEligibleTransportOrderVehicles,
    getTransportOrder: get_GetTransportOrder,
    updateTransportOrder: patch_UpdateTransportOrder,
    cancelTransportOrder: post_CancelTransportOrder,
    getTransportOrderRoute: get_GetTransportOrderRoute,
} as const satisfies Record<TransportOrderEndpointName, OpenApiResponseSchemas>;
